import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IUser } from "@common/interfaces/user";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";

export interface UserState extends EntityState<IUser, ID> { }

@Injectable({
    providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.USERS , realtimeEntity: 'User'})
export class UserStore extends EntityStore<UserState> {
    constructor() {
        super([]);
    }
}
